import { useRef, useEffect } from "react";
import { useSelector } from "react-redux";
//import moment from "moment";
import moment from "moment-timezone";

// Full JSON array of soccer matches, it will be replaced with the actual fetched data
let matches = [];

export default function SoccerDropdown({
  displaySubMenu,
  setDisplaySubMenu,
  gameType
}) {
  const eventsFromParent = useSelector((state) => state.event);

  let SportsText = "";
  if (gameType == 0) {
    SportsText = "";
  } else if (gameType == 1) {
    SportsText = "All Cricket";
    if (eventsFromParent.data != null && eventsFromParent.data != undefined) {
      getSportListById(eventsFromParent.data.result, gameType);
    }
  } else if (gameType == 2) {
    SportsText = "All Soccer";
    if (eventsFromParent.data != null && eventsFromParent.data != undefined) {
      getSportListById(eventsFromParent.data.result, gameType);
    }
  } else if (gameType == 3) {
    SportsText = "All Tennis";
    if (eventsFromParent.data != null && eventsFromParent.data != undefined) {
      getSportListById(eventsFromParent.data.result, gameType);
    }
  } else if (gameType == 4) {
    SportsText = "All Horse Race";
    if (eventsFromParent.data != null && eventsFromParent.data != undefined) {
      getSportListById(eventsFromParent.data.horse, gameType);
    }
  } else if (gameType == 5) {
    SportsText = "All Greyhound";
    if (eventsFromParent.data != null && eventsFromParent.data != undefined) {
      getSportListById(eventsFromParent.data.grey, gameType);
    }
  }

  const subMenuRef = useRef(null);
  // Function to handle clicks outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (subMenuRef.current && !subMenuRef.current.contains(event.target)) {
        setDisplaySubMenu(false); // Or update any value/state you want
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind on cleanup
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [subMenuRef]);

  function getSportListById(data, gameType) {
    let events = data.filter((event) => event.sports_type === gameType);
    if (gameType === 1 || gameType === 2 || gameType === 3) {
      matches = [];

      for (let i = 0; i < events.length; i++) {
        let obj = events[i];
        let mongoTime = obj.evt_od.$date.$numberLong;
        let eventDate = moment(Number(mongoTime))
          .local()
          .format("DD-MM-YYYY hh:mm:ss A");

        let record = {};
        record.name = obj.name;
        record.mid = obj.mid;
        record.evt_od = obj.evt_od;
        record.eventDate = eventDate;
        matches.push(record);
      }
    } else if (gameType === 4 || gameType === 5) {
      matches = [];

      for (let i = 0; i < events.length; i++) {
        let obj = events[i];
        let record = {};
        record.mid = obj.mid;
        let mongoTime = obj.evt_od.$date.$numberLong;
        let eventDate = moment(Number(mongoTime)).local().format("hh:mm A");
        record.name = eventDate + " " + obj.masterEventName;

        record.eventDate = eventDate;
        matches.push(record);
      }
    }
  }

  return (
    <ul
      className={displaySubMenu ? "dropdown-menu show" : "dropdown-menu"}
      aria-labelledby="navbarDropdownMenuLink"
      ref={subMenuRef}
    >
      <div
        style={{
          textAlign: "left",
          padding: 10,
          color: "white",
          borderBottom: "solid"
        }}
      >
        {SportsText}
      </div>
      <div id="left_soccer_div">
        {matches.map((match, idx) => (
          <li key={idx}>
            <a
              className="dropdown-item"
              style={{
                fontSize: 14,
                color: "white",
                textWrap: "wrap",
                marginBottom: 2,
                lineHeight: "14px"
              }}
              href={`/market/${match.mid}`}
              rel="noopener noreferrer"
            >
              {match.name}
            </a>
          </li>
        ))}
      </div>
    </ul>
  );
}
